<template>
  <div>
    <div class="heading">
      <h1>{{transHotelName}}</h1>
      <div class="d-flex retingbox" v-if="rating>2">
        <b-form-rating
          class="ui rating"
          v-model="rating"
          variant="warning"
          locale="he"
          readonly
        ></b-form-rating>
      </div>
    </div>
    <!------ kremlin list area start ------->
    <div class="kremlin-list">
      <ul class="d-flex flex-row">
        <li>
          <figure class="kremlin-box">
            <img :src="`${speedSizeDomain}/assets/img/app/icon3.png`" alt="#" title="" />
            <figcaption>{{ `${transHotelName} - ${transCityName}` }}</figcaption>
          </figure>
        </li>
        <li>
          <figure class="kremlin-box">
            <img :src="`${speedSizeDomain}/assets/img/app/icon2.png`" alt="#" title="" />
            <figcaption>{{ periodVocation }}</figcaption>
          </figure>
        </li>
        <li>
          <figure class="kremlin-box">
            <img :src="`${speedSizeDomain}/assets/img/app/icon1.png`" alt="#" title="" />
            <figcaption>{{ paxList }}</figcaption>
          </figure>
        </li>
      </ul>
    </div>
    <!------ kremlin list area stop ------->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { BFormRating } from 'bootstrap-vue';
import imageUrlMixin from '@/utils/imageUrlMixin';

export default {
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  components: {
    BFormRating,
  },
  mixins: [imageUrlMixin],
  data() {
    return {
      periodVocation: '',
      paxList: '',

      transCityName: '',
      transHotelName: '',
    };
  },
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
    }),
    remark() {
      // return this.product?.remarkTranslation?.[this.lang] ?? this.product?.remark ?? '';
      return this.product.remark ?? '';
    },
    rating() {
      return Number(this.product.hotels[0]?.grade.substr(0, 1));
    },
  },
  watch: {
    lang: 'updateLabelWithLang',
  },
  created() {
    const from = dayjs(this.product.fromDate),
      to = from.add(this.product.duration_1, 'day');
    this.periodVocation = `${from.format('DD/MM/YYYY')}-${to.format('DD/MM/YYYY')}`;
    const { roomList } = JSON.parse(window.sessionStorage.getItem('roomList'));
    let ctAdult = 0, ctChild = 0, ctInfant = 0;
    roomList.forEach((room) => {
      ctAdult += room.adult;
      ctChild += room.child;
      ctInfant += room.infant;
    });
    if (ctAdult) this.paxList += `${this.$t('booking.adults')} ${ctAdult}`;
    if (ctChild) this.paxList += ` | ${this.$t('booking.children')} ${ctChild}`;
    if (ctInfant) this.paxList += ` | ${this.$t('booking.infants')} ${ctInfant}`;

    this.updateLabelWithLang();
  },
  methods: {
    updateLabelWithLang() {
      // eslint-disable-next-line no-mixed-operators
      this.transCityName = this.product.translations?.city && this.product.translations?.city[this.product.hotels[0].city][this.lang] || this.product.hotels[0]?.cityName;
      this.transHotelName = this.product.hotels[0]?.hotelName; // this.product.translations.hotelName && this.product.translations.hotelName[this.product.hotels[0].La_ID][this.lang] || this.product.hotels[0].hotelName;
    },
  },
};
</script>

<style>
/* ====================================================================== */
/* R5 Batch 10: kremlin-area2 background must be edge-to-edge              */
/* ====================================================================== */
.kremlin-area.kremlin-area2 {
  position: relative;
  width: 100vw !important;
  max-width: 100vw !important;
  margin-left: calc(-50vw + 50%) !important;
  margin-right: calc(-50vw + 50%) !important;
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
/* Add a subtle blue gradient overlay so even with low-color background image the contrast is good */
.kremlin-area.kremlin-area2::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(28, 126, 214, 0.55) 0%, rgba(28, 126, 214, 0.78) 100%);
  z-index: 0;
  pointer-events: none;
}
.kremlin-area.kremlin-area2 > * {
  position: relative;
  z-index: 1;
}
</style>

<style scoped>
/* ====================================================================== */
/* R5 Batch 7: Premium booking-page top header                             */
/* ====================================================================== */
.heading {
  text-align: center;
  margin: 14px auto 16px;
  max-width: 720px;
  padding: 0 12px;
}
.heading h1 {
  font-size: 22px !important;
  font-weight: 700 !important;
  color: #ffffff;
  margin: 0 0 8px !important;
  letter-spacing: -0.3px;
}
.heading .retingbox {
  justify-content: center;
  margin-bottom: 4px;
}
.heading .retingbox .b-rating {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
}

.kremlin-list {
  margin: 14px auto;
  max-width: 720px;
  padding: 0 8px;
}
.kremlin-list ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.kremlin-list ul li {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}
.kremlin-list .kremlin-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  text-align: center;
  width: 100%;
  min-height: 78px;
  margin: 0;
  padding: 10px 4px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.kremlin-list .kremlin-box img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex: 0 0 22px;
}
.kremlin-list .kremlin-box figcaption {
  /* Explicit font-family + size + weight so all 3 boxes look identical
     regardless of which characters they contain (mixed Hebrew + Latin
     was making "11/05/26" look heavier than "מספר מבוגרים: 2") */
  font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  font-size: 11px !important;
  line-height: 1.35 !important;
  color: #1c4e80 !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  width: 100%;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
}
@media (max-width: 380px) {
  .kremlin-list .kremlin-box {
    padding: 8px 3px;
    min-height: 72px;
  }
  .kremlin-list .kremlin-box figcaption {
    font-size: 10px !important;
  }
}

.heading_area {
  width: 100%;
  padding: 20px 0px;
  background: rgb(2, 0, 36);
  background: linear-gradient(
    180deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(1, 98, 172, 1) 0%,
    rgba(38, 135, 209, 1) 100%
  );
}
.heading_area .heading_body_area h1 {
  color: #ffffff;
  font-size: 16px;
  margin: 0 0 6px;
  letter-spacing: normal;
  font-weight: 600;
  position: relative;
  padding-right: 20px;
}
.heading_area .heading_body_area h1 .icon {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}
.heading_area .heading_body_area h2 {
  color: #ffffff;
  font-size: 16px;
  margin: 0 0 6px;
  letter-spacing: normal;
  font-weight: 600;
  position: relative;
  padding-right: 20px;
}
.heading_area .heading_body_area h2 .icon {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}
.heading_area .heading_body_area h3 {
  color: #ffffff;
  font-size: 14px;
  margin: 0 0 6px;
  letter-spacing: normal;
  font-weight: 400;
  position: relative;
  padding-right: 20px;
}
.heading_area .heading_body_area h3 .icon {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}
.heading_area .heading_body_area h3:last-child {
  margin-bottom: 0px;
}
</style>

<style lang="less" scoped>
  .bonauf-desktop {
    .heading {
      max-width: 780px;
      margin: auto;
      margin-bottom: 20px;
      
      .kremlin-box {
        img {
          height: 60px;
        }
      }
    }
  }
</style>
